export default __webpack_public_path__ + "static/media/photo8.5abd5eee.jpg";